<template>
  <v-card class="settings-card-primary cost-per-record-form pa-0">
    <div class="d-flex w-100 align-baseline pa-7">
      <v-card-title style="font-weight: bold" class="pa-0">Exports Audit</v-card-title>
    </div>
    <div>
      <v-data-table
        :headers="header"
        :items="items"
        item-key="userId"
        :hide-default-footer="!items.length"
        class="light-table"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.userName">
              <td>{{ item.source }}</td>
              <td>{{ item.number_of_records }}</td>
              <td>{{ getUserName(item.user_id) }}</td>
              <td>{{ format(item.datetime) }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <div
        v-if="!items.length"
      >
        <no-data-found
        class="no-data"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import NoDataFound from '@/components/Global/NoDataFound'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ExportAudit',
  components: {
    NoDataFound
  },
  data () {
    return {
      header: [
        { text: 'Source', value: 'source' },
        { text: 'Records', value: 'number_of_records' },
        { text: 'User', value: 'user_id' },
        { text: 'Date', value: 'datetime' }
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'currentOrganization', 'getExports']),
    items () {
      return this.getExports
    }
  },
  mounted () {
    this.currentOrganization && this.$store.dispatch('loadExports', { organization_id: this.currentOrganization.entity_id })
  },
  methods: {
    getUserName (userId) {
      const res = this.currentOrganization.users.filter(user => user.user_id == userId)
      return res.length ? res[0].email : 'User removed'
    },
    format (datetime) {
      return moment(datetime, 'X').format('YYYY-MM-DD hh:mm a')
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-data {
    margin: auto;
    display: flex;
    flex-direction: column;
    width: fit-content;
    height: fit-content;
    padding: 15px;
    span {
      color: $dark-gray-color;
      margin-top: 10px;
    }
    .v-icon {
      color: $dark-gray-color;
    }
  }
</style>
